import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "form-item" }, [
  /*#__PURE__*/_createVNode("label", null, "使用权限：")
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 确定 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_radio_group = _resolveComponent("a-radio-group")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_menu_list = _resolveComponent("menu-list")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.store.state.packages.addState,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.store.state.packages.addState = $event)),
    width: "700px",
    class: "add-pkg-modal ant-model-table",
    title: _ctx.detail ? '编辑功能包' : '新增功能包',
    afterClose: _ctx.afterClose,
    onCancel: _ctx.afterClose,
    maskClosable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.afterClose
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        loading: _ctx.loading,
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        "label-col": { span: 6 },
        "wrapper-col": { span: 18 },
        class: "form-content"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "功能包名称",
            name: "packageName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.packageName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.packageName = $event)),
                placeholder: "请输入功能包名称"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "系统",
            name: "systemId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                placeholder: "请选择系统",
                value: _ctx.form.systemId,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.systemId = $event)),
                style: {"width":"300px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.systemOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "是否是应用功能包",
            name: "isAppPkg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.form.isAppPkg,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.isAppPkg = $event)),
                options: _ctx.appPkgOptions
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "备注",
            name: "remark"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                maxlength: 30,
                style: {"width":"300px"},
                value: _ctx.form.remark,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.remark = $event)),
                placeholder: "请输入备注"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _hoisted_1,
          _createVNode("div", null, [
            _createVNode(_component_a_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menus, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    span: 8,
                    key: item.code
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_menu_list, { node: item }, null, 8, ["node"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "title", "afterClose", "onCancel"]))
}